import { CallType } from '@weblite/ts-action/media-proxy'
import { checkNotificationPermissionDialog } from '$setup/notification'
import { checkContactPermissionDialog } from '$logic/contacts/service'
import { getAuthToken, isLoggedIn } from '$logic/auth'
import {
  sendAuthTokenToTwa,
  sendEventToTwa,
} from '$logic/twaCommunication/twaCommunication.api'
import { TWA_EVENTS } from '$logic/twaCommunication/twaCommunication.types'
import { getInstalledTwaVersion, isInTwa } from '$func/environmentInfo'
import {
  setPort,
  setWsUrl,
} from '$logic/twaCommunication/twaCommiunication.state'
import { getRoom } from '$logic/room'
import { CallNotification } from '$logic/call'
import { SESSION_STORAGE_KEYS } from '$logic/client-device/types'
import {
  sessionStorageGetItem,
  sessionStorageSetItem,
} from '$func/session-storage'
import { getRoomImageAndName } from '$func/room-image-and-name'

const NOTIF_PERM = 'notif_perm'
const CONTACT_PERM = 'contact_perm'

const params = new URLSearchParams(window.location.search)
const notifPermission = params.get(NOTIF_PERM)
const contactPermission =
  params.get(CONTACT_PERM) ||
  sessionStorageGetItem(SESSION_STORAGE_KEYS.CONTACT_PERM)

if (contactPermission)
  sessionStorageSetItem(SESSION_STORAGE_KEYS.CONTACT_PERM, contactPermission)

export const updateTwaPermissions = () => {
  if (!isLoggedIn()) {
    sendEventToTwa(TWA_EVENTS.LOGOUT)
    return
  }

  if (notifPermission && notifPermission !== 'allow')
    checkNotificationPermissionDialog()
  if (contactPermission && contactPermission !== 'allow')
    checkContactPermissionDialog()
  if (contactPermission === 'allow') sendEventToTwa(TWA_EVENTS.SYNC_CONTACT)
}

export const TWA_API_SUPPORT = {
  // OPEN_FILE: isInTwa && getInstalledTwaVersion() > 25,
  OPEN_FILE: false,
  RECONNECT_WEBSOCKET: getInstalledTwaVersion() > 35,
  LEAST_VERSION: 31,
}

export const setTwaAuthToken = (token = getAuthToken()) => {
  if (!isInTwa) return
  sendAuthTokenToTwa(token).catch(() =>
    setTimeout(setTwaAuthToken, 2000, token),
  )
}

export const setTwaHttpServerPort = setPort

export const setTwaWsServerUrl = setWsUrl

async function showCallNotification(
  roomId: string,
  event: TWA_EVENTS,
  callType: CallType = 'call',
) {
  const room = await getRoom(roomId)
  if (!room) return

  const { name, image } = await getRoomImageAndName(room.type, roomId)
  sendEventToTwa(event, {
    roomId,
    callType,
    callName: name,
    roomAvatar: image,
  } as CallNotification)
}

export const twaCommunication = {
  showCallNotification,
}
